"use client";

import { Button } from "@/components/ui/button";
import { YnsLink } from "@/ui/yns-link";
import type { ReactNode } from "react";

export const RequirePKDVerificationClient = ({
	children,
	hidePrice,
}: { children: ReactNode; hidePrice: boolean }) => {
	if (!hidePrice) {
		return children;
	}

	return (
		<div className="flex flex-row items-center">
			<span className="pointer-events-none blur-[5px] select-none">XXX.XXzł</span>
			<Button variant="link" asChild>
				<YnsLink href="/login?next=/account/addresses">Zaloguj się, aby zobaczyć cenę</YnsLink>
			</Button>
		</div>
	);
};
